/* TimeLab editorial motion helpers (loaded by sections/tl-editorial-pages.liquid)
   1. Reveal anything already on screen at load.
   2. Spanish empty-cart label for screen readers.
   3. Home closing CTA heading fitted to the full width on desktop.
   4. Typewriter: texts type out when the existing reveal shows their block (reveal itself untouched). */
(function () {
  function onReady(fn) { if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn); } else { fn(); } }

  function reveal() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll('[data-tle-reveal]:not(.is-visible)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add('is-visible');
    });
  }
  onReady(reveal);
  window.addEventListener('pageshow', reveal);
  onReady(function () {
    var h = document.querySelector('.tle-page-cart .cart__empty-text');
    if (h && document.documentElement.lang.indexOf('es') === 0) h.setAttribute('aria-label', 'Tu carrito está vacío');
  });

  var mqDesk = window.matchMedia('(min-width: 990px)');
  function fitCta() {
    document.querySelectorAll('.tlr__cta h2').forEach(function (h) {
      if (!mqDesk.matches) { h.style.fontSize = ''; return; }
      var box = h.closest('.tlr__cta-inner'); if (!box) return;
      h.style.fontSize = '100px'; h.style.width = 'max-content';
      var w = h.getBoundingClientRect().width;
      h.style.width = '';
      if (!w) { h.style.fontSize = ''; return; }
      h.style.fontSize = Math.min(300, Math.floor(100 * box.clientWidth / w * 0.99)) + 'px';
    });
  }
  onReady(fitCta);
  window.addEventListener('load', fitCta);
  window.addEventListener('resize', fitCta);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitCta);
  document.addEventListener('shopify:section:load', fitCta);

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var BOX = '[data-tle-reveal], [data-tlr-reveal]';
  var TXT = 'h1, h2, h3, h4, p, li, blockquote, .tle-eyebrow, .tlr__eyebrow, .tlr__collection-copy strong, .tle-lc__copy strong, .tle-about__social-row strong';
  var SKIP = 'script, style, svg, select, option, input, textarea, button, .visually-hidden';
  var WS = /(\s+)/, ONLYWS = /^\s+$/;
  function split(el) {
    if (el.dataset.tw) return [];
    el.dataset.tw = '1';
    var chars = [], walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), nodes = [], n;
    while ((n = walker.nextNode())) { if (n.nodeValue.trim() && !(n.parentElement && n.parentElement.closest(SKIP))) nodes.push(n); }
    nodes.forEach(function (node) {
      var frag = document.createDocumentFragment();
      node.nodeValue.split(WS).forEach(function (part) {
        if (!part) return;
        if (ONLYWS.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        var w = document.createElement('span'); w.className = 'tle-tw-w';
        Array.from(part).forEach(function (ch) {
          var c = document.createElement('span'); c.className = 'tle-tw-c'; c.textContent = ch; w.appendChild(c); chars.push(c);
        });
        frag.appendChild(w);
      });
      node.parentNode.replaceChild(frag, node);
    });
    if (chars.length) el.classList.add('tle-tw');
    return chars;
  }
  function targets(box) {
    var list = [];
    if (box.matches(TXT)) list.push(box);
    box.querySelectorAll(TXT).forEach(function (el) { list.push(el); });
    return list.filter(function (el) {
      if (el.dataset.tw || el.querySelector(TXT) || el.closest(SKIP)) return false;
      if (!el.textContent.trim() || parseFloat(getComputedStyle(el).fontSize) === 0) return false;
      return true;
    });
  }
  function type(chars, delay) {
    if (!chars.length) return;
    var step = Math.max(6, Math.min(34, 1500 / chars.length)), shown = 0, t0 = Date.now() + delay;
    function tick() {
      var count = Math.min(chars.length, Math.max(1, Math.floor((Date.now() - t0) / step) + 1));
      for (var i = shown; i < count; i++) chars[i].classList.add('on');
      if (shown) chars[shown - 1].classList.remove('cur');
      chars[count - 1].classList.add('cur');
      shown = count;
      if (shown < chars.length) { setTimeout(tick, 16); }
      else { setTimeout(function () { chars[chars.length - 1].classList.remove('cur'); }, 600); }
    }
    setTimeout(tick, delay);
  }
  function prep(box) { if (!box._tw) box._tw = targets(box).map(split); }
  function play(box) {
    prep(box);
    if (box._twPlayed) return;
    box._twPlayed = true;
    var base = parseFloat(getComputedStyle(box).getPropertyValue('--tle-delay')) || 0, acc = 120 + base;
    box._tw.forEach(function (chars) { type(chars, acc); acc += Math.min(700, chars.length * 12); });
  }
  function scan(root) {
    (root || document).querySelectorAll(BOX).forEach(function (box) {
      prep(box);
      if (box.classList.contains('is-visible')) play(box);
    });
  }
  onReady(function () {
    scan();
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        var el = m.target;
        if (el.classList && el.classList.contains('is-visible') && el.matches(BOX)) play(el);
      });
    }).observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
  });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();